import { QueryStatus } from "@tanstack/react-query"

import { LOADING_TEXT } from "utils/constants"

export function formatLabel<DataType>(
    status: QueryStatus,
    data: DataType[] = [],
    getValue: (arg: DataType[]) => string,
    allLabel = "Все"
): string {
    if (status === "error") return "Ошибка..."
    if (status === "success" && data) {
        const value = getValue(data)
        if (value.length) return value
        return allLabel
    }
    return LOADING_TEXT
}
